import { useSelector } from 'react-redux'

import { storyPaths, selectActiveMapMarkers } from './storyPaths.js'
import StoryMarker from './storyPath/StoryMarker.js'
import OffScreenIndicators from '../map/OffScreenIndicators.js'
import { selectIsOpeningSceneComplete } from './opening_scene/openingSceneSlice.js'

export default function Markers () {
  const isOpeningSceneComplete = useSelector(selectIsOpeningSceneComplete)
  const activeMarkers = useSelector(selectActiveMapMarkers)
  return (
    isOpeningSceneComplete && <>
      {storyPaths.map(({ key, slice, icon, tooltipDirection }) => (
        <StoryMarker key={key} slice={slice} iconUrl={icon} tooltipDirection={tooltipDirection} />
      ))}
      <OffScreenIndicators markers={activeMarkers} />
    </>
  )
}
